import * as React from 'react';

import { ThumbsUpFilledIcon, ThumbsUpIcon } from '@coursera/cds-icons';

import { CoachIconButton } from 'bundles/ai-coach-platform/components/building-blocks';

import _t from 'i18n!nls/ai-coach-platform';

type Props = {
  selected?: boolean;
  onSelect(): void;
  onDeselect(): void;
};

const FeedbackLike = ({ selected, onSelect, onDeselect }: Props) => {
  return (
    <div>
      {selected ? (
        <CoachIconButton
          size="small"
          aria-label={_t('Cancel #{coachLabel} message like', { coachLabel: 'Coach' })}
          tooltip={_t('Cancel like')}
          onClick={onDeselect}
          icon={<ThumbsUpFilledIcon color="default" size="small" />}
        />
      ) : (
        <CoachIconButton
          size="small"
          aria-label={_t('Like #{coachLabel} message', { coachLabel: 'Coach' })}
          tooltip={_t('Like')}
          onClick={onSelect}
          icon={<ThumbsUpIcon color="default" size="small" />}
        />
      )}
    </div>
  );
};

export default FeedbackLike;
